import TFS_Host_TfsContext = require("Presentation/Scripts/TFS/TFS.Host.TfsContext");
import Ajax = require("Presentation/Scripts/TFS/TFS.Legacy.Ajax");
import Utils_Core = require("VSS/Utils/Core");
import Work_WebApi = require("TFS/Work/RestClient");
import VSS_Service = require("VSS/Service");
import TFS_Core_Contracts = require("TFS/Core/Contracts");
import Contracts = require("TFS/Work/Contracts");
import { FeatureAvailabilityService } from "VSS/FeatureAvailability/Services";

export interface IReorderAjaxResponse {
    success: boolean;
    updatedWorkItemIds?: number[];
    updatedWorkItemOrders?: number[];
}

/**
 * A reorder operation object which looks like:
 * {
 *     ParentId: The ID of the parent within which we are reordering. Use 'null' to infer parent from ReorderId.
 *     Ids
 *     PreviousId
 *     NextId
 *     IterationPath
 * }
 */
export interface IReorderWorkItemsInput {
    Ids: number[];
    ParentId: number;
    PreviousId: number;
    NextId: number;
    IterationPath?: string;
}

export function reorderProductBackLogWorkItems(
    teamId: string,
    inputs: IReorderWorkItemsInput[],
    onSuccess: (response: IReorderAjaxResponse) => void,
    onFailed: (error: Error) => void
) {
    if (FeatureAvailabilityService.isFeatureEnabled("WebAccess.Agile.Backlog.ReorderWorkItemsRest", false)) {
        reorderWorkItemsHelper(teamId, inputs).then(onSuccess, onFailed);
    } else {
        const apiLocation = TFS_Host_TfsContext.TfsContext.getDefault().getActionUrl("Reorder", "ReorderWorkItems", {
            area: "api",
            teamId
        } as TFS_Host_TfsContext.IRouteData);

        Ajax.postMSJSON(
            apiLocation,
            {
                operations: Utils_Core.stringifyMSJSON(inputs)
            },
            onSuccess,
            onFailed
        );
    }
}

export function reorderIterationWorkItems (
    teamId: string,
    inputs: IReorderWorkItemsInput[],
    onSuccess: (response: IReorderAjaxResponse) => void,
    onFailed: (error: Error) => void,
    iterationId: string
) {
    if (FeatureAvailabilityService.isFeatureEnabled("WebAccess.Agile.Backlog.ReorderWorkItemsRest", false)) {
        reorderWorkItemsHelper(teamId, inputs, iterationId).then(onSuccess, onFailed);
    } else {
        const apiLocation = TFS_Host_TfsContext.TfsContext.getDefault().getActionUrl("Reorder", "ReorderWorkItems", {
            area: "api",
            teamId
        } as TFS_Host_TfsContext.IRouteData);

        Ajax.postMSJSON(
            apiLocation,
            {
                operations: Utils_Core.stringifyMSJSON(inputs)
            },
            onSuccess,
            onFailed
        );
    }
}

export async function reorderWorkItemsHelper(
    teamId: string,
    inputs: IReorderWorkItemsInput[],
    iterationId?: string
): Promise<IReorderAjaxResponse> {
    var tfsContext = TFS_Host_TfsContext.TfsContext.getDefault();
    var tfsConnection = new VSS_Service.VssConnection(tfsContext.contextData);
    var workHttpClient = tfsConnection.getHttpClient<Work_WebApi.WorkHttpClient>(Work_WebApi.WorkHttpClient);
    var teamContext = <TFS_Core_Contracts.TeamContext>{
        projectId: tfsContext.contextData.project.id,
        teamId: teamId
    };
    const reorderResult: IReorderAjaxResponse = { success: true, updatedWorkItemIds: [], updatedWorkItemOrders: [] };
    for (const input of inputs) {
        const operation = _mapClientToServerReorderInputDataContract(input);
        let response: Contracts.ReorderResult[];
        if (iterationId) {
            response = await workHttpClient.reorderIterationWorkItems(operation, teamContext, iterationId);
        } else {
            response = await workHttpClient.reorderBacklogWorkItems(operation, teamContext);
        }
        response.forEach(reorder => {
            reorderResult.updatedWorkItemIds.push(reorder.id);
            reorderResult.updatedWorkItemOrders.push(reorder.order);
        });
    }
    return reorderResult;
}

function _mapClientToServerReorderInputDataContract(input: IReorderWorkItemsInput): Contracts.ReorderOperation {
    return {
        ids: input.Ids,
        nextId: input.NextId,
        parentId: input.ParentId,
        previousId: input.PreviousId,
        iterationPath: input.IterationPath
    };
}

export function reorderWorkItemsAsync(teamId: string, inputs: IReorderWorkItemsInput[]): Promise<IReorderAjaxResponse> {
    return new Promise((resolve, reject) => {
        reorderProductBackLogWorkItems(teamId, inputs, resolve, reject);
    });
}
